import * as React from "react";
import {Text} from "recharts";

interface IHorizontalAxisTick {
    angle?: number,
    textAnchor?: "inherit" | "start" | "middle" | "end" | undefined,
    fontSize?: number,
    tickFormatter? : any
}


export class HorizontalAxisTick extends React.Component<IHorizontalAxisTick> {
    
    public static defaultProps = {
        angle: 0,
        textAnchor: "end"
    };    

    public render () {
        const {x, y, payload,fontSize,tickFormatter} = (this.props) as any;

        let formattedValue;

        if(tickFormatter !== undefined){
            formattedValue = tickFormatter(payload.value);
        }else{
            formattedValue = payload.value;
        }
 
        return(
        <g transform={`translate(${x},${y})`}>
            <Text style={{"whiteSpace": "nowrap"}} x={0} y={0} dy={15} angle={this.props.angle} textAnchor={this.props.textAnchor} fill="#666" transform="rotate(0)" fontSize={fontSize} width={5} >{formattedValue}</Text>
        </g>);
      }  
}



export class VerticalAxisTick extends React.Component<any> {

      public render () {
        const {x, y,  payload,fontSize, tickFormatter} = this.props;
        let label;
        let tickCutOff = 30;

        if(this.props.tickCutOff !== undefined){
            tickCutOff = this.props.tickCutOff;
        }

        let formattedValue;
        if(tickFormatter !== undefined){
            formattedValue = tickFormatter(payload.value);
        }else{
            formattedValue = payload.value;
        }

        if(formattedValue.length > tickCutOff){
            label = formattedValue.substr(0,tickCutOff - 4) + "..."
        }else{
            label = formattedValue
        }

        return(
        <g transform={`translate(${x},${y})`}>
            <Text textAnchor="end" fill="#666" transform="rotate(0)" fontSize={fontSize} >{formattedValue} </Text>
        </g>);
      }  
}




// WEBPACK FOOTER //
// ./src/components/charts/AxisTick.tsx